<div class="carousel-container" [class.no-padding]="noSpace">
    <span class="carousel-control prev" (click)="previous()" [class.content-icon-carousel]="contentTable">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
    </span>

    <div class="carousel-content">
        <div class="carousel-item" *ngFor="let item of visibleItems; let i = index"
            [ngStyle]="showShadow ? { 'box-shadow': 'rgba(153,153,153,0.15)' } : null" [class.no-margin]="noSpace">
            <div [class.carousel-header]="item.title">
                <div class="card-ic">
                    <div class="card-header">
                        <label class="titulo-contenido-documento">{{item.DescripcionDocumento}} <span>{{item.NroDocumento}}</span></label>
                    </div>
                    <div class="card-body content-img">
                        <app-loader-spinner *ngIf="item.loader"></app-loader-spinner>
                        <lib-ngx-image-zoom [thumbImage]=item.thumbnail [fullImage]=item.fullImage [magnification]="0.15"
                            [enableScrollZoom]="false" [circularLens]="false" [enableLens]="true" [lensWidth]="600"
                            [lensHeight]="800" (click)="openModal(item)">
                        </lib-ngx-image-zoom>
                        <div *ngIf="item.error" class="contenido-image-error">
                            <img src="./../../assets/illustrations/sin-previsualizacion.svg" alt="">
                            <p><span>Documento sin previsualización</span><br>
                                Por favor, contacta a la mesa de ayuda para habilitar un formato de impresión. 
                            </p>
                        </div>
                    </div>
                    <div class="card-footer">
                    </div>
                </div>
                <div class="card-footer">

                </div>
            </div>
            <ng-container *ngTemplateOutlet="item.content"></ng-container>
        </div>
    </div>

    <span *ngIf="controlPaginadorNormal || contentTable" class="carousel-control next" (click)="next()"
        [class.content-icon-carousel]="contentTable">
        <fa-icon [icon]="faChevronRight"></fa-icon>
    </span>

    <div class="carousel-dots">
        <span class="dot" *ngFor="let dot of dots; let i = index" [class.active]="isActiveDot(i)"
            (click)="goToSlide(i)">
        </span>
    </div>
</div>
